import Skeleton from "react-loading-skeleton";

import { ConnectedAccountRowSkeleton } from "./ConnectedAccountRowSkeleton";
import styles from "./ConnectedAccounts.module.scss";

export const ConnectedAccountsSkeleton = () => {
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <h3>Connected Accounts</h3>
        <Skeleton height={42} width={140} />
      </div>
      <table>
        <thead>
          <tr>
            <th>Account</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: 3 }).map((_, index) => (
            <ConnectedAccountRowSkeleton key={index} />
          ))}
        </tbody>
      </table>
    </div>
  );
};
